/**
 * + / - buttons handling
 */
(($) => {

    // The Element
    const ROW_ELEMENT = '.cart-item-amount';
    const INCREASE_IDENTIFIER = 'icon-plus';
    const TRIGGER_IDENTIFIER = '.icon';

    $(window).ready(() => {

        // row identifier
        let ItemAmountField = $(ROW_ELEMENT);

        // event handler
        ItemAmountField.find(TRIGGER_IDENTIFIER).on('click', (event) => {

            let trigger = $(event.currentTarget);
            let direction = (trigger.hasClass(INCREASE_IDENTIFIER)) ? 1 : -1;
            let input = $(trigger.parents(ROW_ELEMENT).find('input').get(0));
            let currentValue = parseInt(input.val());

            // avoid minus values
            if (currentValue < 1 && direction < 0) {
                direction = 0;
            }

            input.trigger("itemAmountChange", [currentValue, direction]);

            input.val(currentValue + direction).trigger('change');

        });
    });

})(jQuery);
